import { combineReducers } from 'redux';

import authReducer from './authReducer';
import languageReducer from './languageReducer';
import disableButtonsReducer from './disableButtonsReducer';
import toggleModalReducer from './toggleModalReducer';
import usersReducer from './usersReducer';
import sensorsReducer from './sensorsReducer';
import communitySensorsReducer from './communitySensorsReducer';
import fieldsReducer from './fieldsReducer';
import fieldGroupsReducer from './fieldGroupsReducer';
import notificationsReducer from './notificationsReducer';
import companiesReducer from './companiesReducer';
import weatherStationsReducer from "./weatherStationsReducer";
import weatherDataReportsReducer from "./weatherDataReportsReducer";
import alertRulesReducer from "./alertRulesReducer";
import sensorReportsReducer from "./sensorReportsReducer";
import calibrationValuesReducer from "./calibrationValuesReducer";
import warmHoursReducer from "./warmHoursReducer";
import coldHoursReducer from "./coldHoursReducer";
import drainStationsReducer from "./drainStationsReducer";
import gateSwitchersReducer from "./gateSwitchersReducer";
import weatherStationStatusReportsReducer from "./weatherStationStatusReportsReducer";
import directNotificationsReducer from "./directNotificationsReducer";
import sensorGroupsReducer from "./sensorGroupsReducer";
import userNoticesReducer from "./userNoticesReducer";

const mainReducer = combineReducers({
    authError: authReducer,
    language: languageReducer,
    disableButtons: disableButtonsReducer,
    modalState: toggleModalReducer,
    users: usersReducer,
    sensors: sensorsReducer,
    communitySensors: communitySensorsReducer,
    fields: fieldsReducer,
    fieldGroups: fieldGroupsReducer,
    notifications: notificationsReducer,
    companies: companiesReducer,
    weatherStations: weatherStationsReducer,
    weatherDataReports: weatherDataReportsReducer,
    sensorReports: sensorReportsReducer,
    alertRules: alertRulesReducer,
    calibrationValues: calibrationValuesReducer,
    hours: warmHoursReducer,
    coldHours: coldHoursReducer,
    drainStations: drainStationsReducer,
    gateSwitchers: gateSwitchersReducer,
    weatherStationStatusReports: weatherStationStatusReportsReducer,
    directNotifications: directNotificationsReducer,
    sensorGroups: sensorGroupsReducer,
    userNotices: userNoticesReducer,
});

export default mainReducer;
